var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":_vm.title,"width":1780,"visible":_vm.visible,"footer":null,"ldata":_vm.data},on:{"cancel":function () {
      _vm.$emit('cancel');
    }}},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('a-table',{attrs:{"scroll":{ y: 800 },"columns":_vm.columns,"data-source":_vm.data,"pagination":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }